import { createFileRoute } from '@tanstack/react-router';
import { PartnerContentPage } from '@/pages/admin/partner-content/PartnerContentPage';

export const Route = createFileRoute('/admin/partner-content/')({
  component: PartnerContentPage
});
